var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eye - Iconly Pro"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.9985 14.25C11.7773 14.25 14.319 12.2809 15.75 9C14.319 5.71903 11.7773 3.75 8.9985 3.75C6.22275 3.75 3.681 5.71903 2.25 9C3.681 12.2824 6.22275 14.25 9.0015 14.25H8.9985Z",
    stroke: "#3F906D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3091 9.00381C11.3091 10.2588 10.2756 11.2774 9.0021 11.2774C7.72785 11.2774 6.69434 10.2588 6.69434 9.00381C6.69434 7.74801 7.72785 6.72949 9.0021 6.72949C10.2756 6.72949 11.3091 7.74801 11.3091 9.00381Z",
    stroke: "#3F906D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.e83979f60a17d9b4fd50abfefbc47ccd.svg";
export { ForwardRef as ReactComponent };